module.exports = __webpack_public_path__ + "static/elementos-ir-570-37ca6afa5aba904c0c7e7e43ac71bca0.jpg";